import React from "react";
import { Tooltip, ResponsiveContainer, PieChart, Pie } from "recharts";

const GenderGroup = ({ title, value, employee }) => {
  const male = employee.filter((emp) => emp.sex === "Male");
  const female = employee.filter((emp) => emp.sex === "Female");
  const plantilla = [
    {
      name: "Male",
      value: male.length,
    },
    {
      name: "Female",
      value: female.length,
    },
  ];

  return (
    <div style={{ width: "100%", height: 300 }}>
      <h5>{title}</h5>
      <ResponsiveContainer>
        <PieChart width={1000} height={1000}>
          <Pie dataKey="value" data={plantilla} fill="#8884d8" label />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GenderGroup;
